import { useFormik } from "formik";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { login } from "../../../../api/auth";
import { authActions } from "../_redux/authActions";

const initialValues = {
  email: "",
  password: "",
};

const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Introduce una dirección de correo válida.")
    .required("El correo electrónico es obligatorio."),
  password: Yup.string().required("La contraseña es obligatoria."),
});

export default function Login() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);

      try {
        const response = await login(values.email, values.password);
        dispatch(authActions.loginActionSuccess(response.data));
      } catch (error) {
        dispatch(authActions.loginActionFailure());
        setStatus("No se ha podido iniciar sesión. Revisa tus credenciales.");
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const inputClassName = (fieldName) =>
    `form-control h-auto py-4 px-5 ${
      formik.touched[fieldName] && formik.errors[fieldName] ? "is-invalid" : ""
    }`;

  return (
    <div>
      <div className="mb-12">
        <img
          src={toAbsoluteUrl("/media/logo/NEO4Logo.jpg")}
          alt="NEO 4"
          style={{ display: "block", width: "190px", maxWidth: "100%", height: "auto", marginBottom: "2.5rem" }}
        />
        <h1 className="font-weight-bolder mb-3" style={{ color: "#182B4D", fontSize: "2.25rem" }}>
          Bienvenido de nuevo
        </h1>
        <p className="mb-0" style={{ color: "#71809A", fontSize: "1rem" }}>
          Introduce tus credenciales para acceder a la plataforma.
        </p>
      </div>

      <form onSubmit={formik.handleSubmit} noValidate>
        {formik.status && (
          <div
            className="mb-7 px-5 py-4"
            role="alert"
            style={{ color: "#B4233C", backgroundColor: "#FFF1F3", borderRadius: "0.5rem" }}
          >
            {formik.status}
          </div>
        )}

        <div className="form-group mb-7">
          <label className="font-weight-bolder mb-3" htmlFor="login-email" style={{ color: "#35445F" }}>
            Correo electrónico
          </label>
          <input
            id="login-email"
            name="email"
            type="email"
            autoComplete="username"
            placeholder="nombre@empresa.com"
            className={inputClassName("email")}
            style={{ borderColor: "#DCE3EF", backgroundColor: "#FFFFFF", borderRadius: "0.45rem" }}
            {...formik.getFieldProps("email")}
          />
          {formik.touched.email && formik.errors.email && (
            <div className="mt-2" style={{ color: "#F64E60", fontSize: "0.82rem" }}>
              {formik.errors.email}
            </div>
          )}
        </div>

        <div className="form-group mb-10">
          <label className="font-weight-bolder mb-3" htmlFor="login-password" style={{ color: "#35445F" }}>
            Contraseña
          </label>
          <input
            id="login-password"
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder="Introduce tu contraseña"
            className={inputClassName("password")}
            style={{ borderColor: "#DCE3EF", backgroundColor: "#FFFFFF", borderRadius: "0.45rem" }}
            {...formik.getFieldProps("password")}
          />
          {formik.touched.password && formik.errors.password && (
            <div className="mt-2" style={{ color: "#F64E60", fontSize: "0.82rem" }}>
              {formik.errors.password}
            </div>
          )}
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100 font-weight-bolder py-4"
          disabled={formik.isSubmitting || loading}
          style={{ borderRadius: "0.45rem", letterSpacing: "0.04em" }}
        >
          {loading ? "Accediendo..." : "Acceder"}
          {loading && <span className="ml-3 spinner spinner-white" />}
        </button>
      </form>
    </div>
  );
}
